module.exports = __webpack_public_path__ + "img/birthBg.af8df2fb.png";